// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { ProjectVersion } from 'model/ProjectMetaMessageExtensions';
import React from 'react';
import styled from 'styled-components';
import AlgorithmResult from './AlgorithmResult';
import { EvaluateQCProgramCompleteMessage } from '@tls/sw91-communication/types/com.api_predictor';

interface Props {
  versions: ProjectVersion[];
  evaluationResults?: Record<ProjectVersion, EvaluateQCProgramCompleteMessage>;
  progress: Record<ProjectVersion, number>;
}
const AlgorithmsEvaluation = ({ versions, evaluationResults, progress }: Props) => {
  return (
    <Root>
      <Content>
        {versions.map(version => (
          <EvaluationContainer key={version} data-testid={`evaluation-algorithm-${version}-result`}>
            <AlgorithmResult
              version={version}
              evaluationResult={evaluationResults?.[version]}
              progress={progress?.[version]}
            />
          </EvaluationContainer>
        ))}
      </Content>
    </Root>
  );
};

const Root = styled.div`
  width: calc(100% - 1rem);
  height: calc(100% - 1rem);
  display: flex;
  padding: 0.5rem;
`;

const EvaluationContainer = styled.div`
  flex: 1;
  height: 100%;
`;
const Content = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  gap: 1rem;
`;

export default AlgorithmsEvaluation;
